import { Button } from '$components'

type Subscription = {
  plan: string
  nextRenewal: string
  status: 'active' | 'inactive'
}

type CurrentSubscriptionProps = {
  data: Subscription
}

export function CurrentSubscription({ data }: CurrentSubscriptionProps) {
  return (
    <div className="mt-4 space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <div className="font-medium">{data.plan} Plan</div>
          <div className="text-sm text-gray-500">
            Next renewal on {data.nextRenewal}
          </div>
        </div>
        <span className="px-2 py-1 text-xs rounded-full bg-indigo-100 text-indigo-700">
          {data.status}
        </span>
      </div>

      <Button
        variant="secondary"
        className="w-full"
      >
        Change Plan
      </Button>
    </div>
  )
}
